import classNames from 'classnames'

import type { PeriodCell } from '../../lib/dateRangeCalendar'
import cn from './PeriodGrid.module.scss'

type PeriodGridProps = {
  cells: PeriodCell[]
  onSelect: (cell: PeriodCell) => void
}

function PeriodGrid({ cells, onSelect }: PeriodGridProps) {
  return (
    <div className={cn.grid}>
      {cells.map((cell) => (
        <button
          key={cell.key}
          type="button"
          disabled={cell.isDisabled}
          aria-pressed={cell.isSelected}
          className={classNames(
            cn.cell,
            cell.isOutside && cn.cellOutside,
            cell.isCurrent && cn.cellCurrent,
            cell.isSelected && cn.cellSelected
          )}
          onClick={() => onSelect(cell)}
        >
          {cell.label}
        </button>
      ))}
    </div>
  )
}

export default PeriodGrid
